import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"

interface Props {
  className?: string
}

export function TransferItemIcon(props: Props) {
  const { _ } = useLingui()

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{_(msg`Transfer item Icon`)}</title>
      <path
        d="M9.06689 11.8948L14.0947 10.2786L9.97915 13.4536C9.67078 13.6915 9.55698 14.1043 9.69996 14.4662L11.2723 18.4464C11.54 19.1241 12.4718 19.1968 12.8417 18.5689L18.8817 8.31757C19.2251 7.73474 18.8042 7 18.1269 7L5.88133 7C5.1201 7 4.72137 7.90283 5.23479 8.46396L8.15196 11.6522C8.38311 11.9049 8.74065 11.9996 9.06689 11.8948Z"
        fill="white"
      />
    </svg>
  )
}
